import request from '@/utils/request'
import qs from 'qs'
// 专题展示位 - 列表
export const getSpecialDisplayList = (data: any) =>
  request({
    url: `/special/show/list`,
    method: 'get',
    params: data
  })

// 专题展示位 - 新增修改
interface IAddEditSpecialDisplay {
  id: number
  specialSeq: number
  name?: string
  isIos: number // 1：ios 3：android
  specialNids: number[] | never[]
  startDate: string
  endDate: string
  isShow: number
  isBanner: number
  bannerType: string
  bannerTypeId: number
  bannerSeq: number
  bannerNids: number[] | never[]
  url: string
  bannerId: number
  status?: number
}
export const addEditSpecailDisplay = (data: IAddEditSpecialDisplay) =>
  request({
    url: `/special/show/option`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
// set top
export const setSpecialTop = (data: { nid: number, ids: string, isTop: 1 | -1 }) =>
  request({
    url: '/special/show/top',
    method: 'post',
    data: qs.stringify(data)
  })
// delete
export const deleteSpecial = (data: { nid: number, ids: string}) =>
  request({
    url: '/special/show/delete',
    method: 'post',
    data: qs.stringify(data)
  })
// sepcial edit info
export const getSpecialEditInfo = (data: any) =>
  request({
    url: '/special/show/edit',
    method: 'get',
    params: data
  })

// ********************* special lib **************************88
// specialLib - list
export const getSpecialLibList = (data: any) =>
  request({
    url: `/special/lib/list`,
    method: 'get',
    params: data
  })
// delete special lib
export const deleteSpecialLib = (data: { ids: string }) =>
  request({
    url: '/special/lib/delete',
    method: 'post',
    data: qs.stringify(data)
  })

// get speciallib edit info
export const getSpecialLibInfo = (data: any) =>
  request({
    url: '/special/lib/edit',
    method: 'get',
    params: data
  })
// sepciallib save & submit
interface IAddEditSpecialLib {
  specialId: number
  defaultLang: string
  name: string
  isIos: number// 1：ios 3：android
  desc: string
  appData: Array<{entityId: any, appName: any}>
  type: string
  draftId: number
  icon: string
}
export const addEditSpecailLib = (data: IAddEditSpecialLib) =>
  request({
    url: `/special/lib/option`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
// 专题库-获取多语言信息
export const getSpecialLangList = (data: any) =>
  request({
    url: `/special/lib/languages`,
    method: 'get',
    params: data
  })
// 专题库-更新新增多语言
export const changeAppSeq = (data: any) =>
  request({
    url: `/special/lib/changeAppSeq`,
    method: 'post',
    params: data
  })
// 专题库-修改专题应用排序
interface IEditSpecialLang {
  specialId: number
  draftId: number
  type: string
  descList: any[]
}
export const editSpecialLang = (data: IEditSpecialLang) =>
  request({
    url: `/special/lib/languages`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// 新增/修改专题
export const addEditSpecial = (data: any) =>
  request({
    url: '/v2/special/lib/saveData',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// 获取专题详情
export const getSpecialDetail = (params: any) =>
  request({
    url: '/v2/special/lib/edit',
    method: 'get',
    params
  })
